import { render, staticRenderFns } from "./25huanghuaqing.vue?vue&type=template&id=042fe9a4&"
import script from "./25huanghuaqing.vue?vue&type=script&lang=js&"
export * from "./25huanghuaqing.vue?vue&type=script&lang=js&"
import style0 from "./25huanghuaqing.vue?vue&type=style&index=0&id=042fe9a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports